<!--添加、编辑用户信息-->
<template>
  <Form
    ref="formRef"
    :formItems="formItems"
    v-model="formData"
    :rules="rules"
    :labelWidth="100"
    @submit="handleSubmit"
    @cancel="handleCancel"
  />
</template>
<script setup>
import {
  ref,
  reactive,
  onMounted
} from 'vue'
import { Form } from '@/layouts/components'
import router from '@/router'
import { LOGIN_PATH } from '@/config/setting'
import {
  showError,
  successMessage,
  errorMessage,
  getRequestData,
  updateFormSelect
} from '@/utils'
import { useUserStore } from '@/stores'
import CryptoJS from 'crypto-js'
const userStore = useUserStore()
const formRef = ref(null)
const submitting = ref(false)
let role='user'

//=========== 接收父件传递的参数 ==========
const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({})
  },
  onClose: Function  // 接收关闭方法
})

//=========== 表单验证规则 ===========
const rules = {
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请再次输入密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== formData.value.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

//=========== 表单数据 ===========
const formData = ref({
  id: '',
  oldPassword: '',
  newPassword: ''
})

// ========== 表单项目 ==========
const formItems=ref([
  {
    type: 'password',
    label: '旧密码',
    prop:'oldPassword',
    placeholder:'请输入旧密码',
    maxlength:8,
    rules: rules.password,
  },
  {
    type: 'password',
    label: '新密码',
    prop: 'newPassword',
    placeholder: '请输入6-8位新密码',
    maxlength:8,
    rules: rules.password
  },
  {
    type: 'password',
    label: '确认新密码',
    prop: 'confirmPassword',
    placeholder: '请再次输入新密码',
    maxlength:8,
    rules: rules.confirmPassword
  }
])

//=========== 取消按钮 ===========
const handleCancel = () => {
  if (props.onClose) {
    props.onClose()
  }
}

//=========== 跳转到登录页 ==========
const redirectToLogin = () => {
  import('vue').then(({ nextTick }) => {
    nextTick(() => {
      router.push(LOGIN_PATH).catch(err => {
        window.location.href = LOGIN_PATH
      })
    })
  })
}

//=========== 确定按钮 ===========
const handleSubmit = async (formData) => {
  if (!formRef.value || submitting.value) return
  const valid = await formRef.value.validate()
  if (!valid) return
  submitting.value = true
  try{
    const result = await getRequestData(`/${role}/modifyPassword`,{
      id: formData.id,
      oldPassword: CryptoJS.MD5(formData.oldPassword.trim()).toString(),
      newPassword: CryptoJS.MD5(formData.newPassword.trim()).toString(),
    })
    if(result.status) {
      await successMessage(result.data || '操作成功')
      await userStore.clearUserInfo()
      // 提交成功后关闭弹窗
      if (props.onClose) props.onClose()
      setTimeout(() => {
        redirectToLogin()
      }, 500)
    }
    else errorMessage(result.data || '操作失败')
    submitting.value = false
  }catch(e){
    showError(e)
  }finally{
    submitting.value = false
  }
}

// ========== 初始化数据 ==========
onMounted(async () => {
  role=(userStore.role.includes('SYSTEM_ADMIN') || userStore.role.includes('ADMIN'))?'admin':'user'
  formData.value.id=props.initialData.id
})
</script>

